require("./lib/social");
require("./lib/ads");
// var track = require("./lib/tracking");

require("./audio");

var $ = require("./lib/qsa");

var scenes = $(".parallax-scene");

scenes.forEach(function(scene) {

  var layers = $(".layer", scene).map(l => ({
    element: l,
    movement: l.getAttribute("movement"),
    depth: l.getAttribute("depth") * 1,
    slide: l.getAttribute("distance") * 1,
    min: l.getAttribute("min") * 1
  }));

  var updateScene = function() {

    var bounds = scene.getBoundingClientRect();
    if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;

    var vh = window.innerHeight;

    var cover = vh + bounds.height;
    var scrolled = bounds.top - vh;
    var delta = -scrolled / cover;
    var normal = delta * 2 - 1;

    layers.forEach(function(l) {
      var shift = {
        x: 0,
        y: 0,
        z: 1
      };

      switch (l.movement) {
        case "horizontal":
          shift.x = l.depth * 50 * normal;
        break;

        case "zoom":
          shift.z = l.min + l.depth * delta;
        break;

        case "vertical":
          shift.y = l.depth * 50 * normal;
        break;
      }

      var t = `translateX(${shift.x}%) translateY(${shift.y}%) translateZ(0) scale(${shift.z})`;
      l.element.style.transform = t;

    });

  };

  window.addEventListener("scroll", updateScene);

  setTimeout(updateScene, 1000);

});